// Garde « testeur Live School » côté client : qui voit le bouton « Tester ce
// défi » (rejouer le vrai player hors créneau). Miroir de la garde serveur
// `_shared/live-tester.ts` (staff @jeraisonne.fr / admin), + localhost (DEV)
// pour le confort de dev. ⚠️ L'edge fn `live-test` garde en dur `@jeraisonne.fr`
// / admin : sur localhost avec un compte non-staff, le bouton s'affiche mais
// l'action renvoie 403 — on utilise un compte staff en dev.

/** Email autorisé à tester (miroir du serveur). Pur, testable. */
export function isTesterEmail(email?: string | null): boolean {
  const e = (email ?? '').trim().toLowerCase();
  return e.endsWith('@jeraisonne.fr') || e === 'philippe.hoton@gmail.com';
}

/** Vrai si l'utilisateur courant peut lancer un test de défi (UI). */
export function isLiveTester(
  profile: { role?: string | null } | null | undefined,
  email?: string | null,
): boolean {
  if (import.meta.env.DEV) return true;
  if (profile?.role === 'admin') return true;
  return isTesterEmail(email);
}
